<template>
	<div class="user-info-main-div">
		<el-descriptions :title="$t('vip.console')" :labelStyle="{ color : '#909399' }" class="el-descriptions-custom20221012">
			<el-descriptions-item :label="$t('vip.username')" :span="3">{{ loginUser.username }}</el-descriptions-item>
			<el-descriptions-item :label="$t('vip.membership.name')" :span="3">
				<span v-if="isVip(loginUser)">
					<el-tag size="mini"  class="vip-btn-background-css" style="border: 0;">VIP</el-tag>
				</span>
				<span v-else>
					{{ getMembershipByLevel(loginUser.level || 0).name }}
				</span>
				<span>&nbsp;
					<span v-if="isVip(loginUser)">( {{$t('vip.expiration_date')}}: {{  $fomatTime(loginUser.expiration, 'yyyy-MM-DD HH:mm:ss') }} )</span>
					<el-button v-else @click="$router.push('/vip/buyVip')" size="mini" class="vip-btn-background-css">{{$t('vip.buy_vip')}}</el-button>
				</span>
			</el-descriptions-item>
			<el-descriptions-item :label="$t('vip.devices')" :span="3">
				{{ loginUser.loginNum }} / {{ loginUser.maxLoginNum }}
			</el-descriptions-item>
			<el-descriptions-item :label="$t('vip.social.account')" :span="3">
				<span style="color: #67C23A;" v-if="loginUser.wxBanding">
					<i class="fa fa-wechat" aria-hidden="true"></i>&nbsp;
					{{$t('vip.social.bind')}}
				</span>
				<span v-else>
					<i class="fa fa-wechat" aria-hidden="true"></i>&nbsp;
					<a>{{$t('vip.social.unbind')}}</a>
				</span>
			</el-descriptions-item>
			<el-descriptions-item :label="$t('vip.affiliate.link')" :span="3">
				<span v-if="!loginUser.invitationCode">
					<el-button v-loading="createCodeLoading" type="primary" @click="createCode(null)"
						size="mini" :disabled="createCodeLoading">{{$t('vip.affiliate.generate')}}</el-button>
				</span>

				<span v-else>
					<el-input size="small" disabled :value="invitationUrl" :style="'width:' + invitationUrl.length * 7 + 'px'" ></el-input>
					<copy-sub style="font-size: 18px;margin-left: 10px" :value="invitationUrl">
						<el-button type="primary" size="small">{{$t('app.copy')}}</el-button>
					</copy-sub>
				</span>
			</el-descriptions-item>
		</el-descriptions>

		<el-dialog :visible.sync="bindAccountObj.visible" width="550px" top="200px">

		</el-dialog>
	</div>
</template>

<script>
import { authorityMethods } from "@/components/common/member/member";
import { api_createInvitationCode_userInfo } from "@/components/api/userInfo";
import COPY_SUB from "@/components/template/otherSub/copySub";
import { api_getWxQrCode_login, api_qrBack_login } from "@/components/api/oauth2";
import { setToken } from "@/components/common/utils/tokenAuth";

export default {
	inject: ['F_alertMsg', 'F_windowLoading', 'WINDOW','F_LOGIN', 'F_getErrMSg', 'LOGINUSER'],
	mixins : [authorityMethods],
	name: "index",
	data() {
		return {
			loginUser: this.LOGINUSER,
			createCodeLoading : false,
			bindAccountObj :{
				visible : false,
			}
		}
	},
	computed : {
		membershipMap() {
			return [
					{ level: 0, key: 'normal', name: this.$t('vip.membership.normal') },
					{ level: 1, key: 'platinum', name: this.$t('vip.membership.platinum')},
			]
		},
		invitationUrl(){
			return window.location.protocol+'//' + location.host + '/invitation?referrer=' + this.$data.loginUser.invitationCode;
		}
	},
	components:{
		'copy-sub': COPY_SUB,
	},
	destroyed() {
		clearTimeout(this.$data.timer)
	},
	created() {
	}, methods: {
		loadWxQrCode : function(this_) {
			this_ = this_ || this
			if (this_.$data.loading){
				this_.F_alertMsg('请勿重复生成',3)
				return
			}
			// 开启遮罩
			this_.$data.loading = true
			api_getWxQrCode_login('banding').then(res => {
				// 关闭遮罩
				this_.$data.loading = false
				this_.$data.qrCode = res.data
				// 执行轮询
				this_.$options.methods.checkQrBack(this_,this_.$data.qrCode.ticket,1,this_.$data.qrCode.expireSeconds)
			}).catch(err => {
				// 关闭遮罩
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err,"获取登录二维码失败"),4)
			})
		},
		checkQrBack : function(this_,ticket,num,expireSeconds) {
			if (num === expireSeconds){// 超出过期时间 跳出轮询
				return
			}
			this_ = this_ || this
			api_qrBack_login(ticket).then(res => {
				// status后端枚举中
				if (res.data.eventStatus === 'created'){// 未扫码状态
					this_.$data.timer = setTimeout(() => {
						this_.$options.methods.checkQrBack(this_,ticket,++num,expireSeconds)
					},1000)
				}else if (res.data.eventStatus === 'fail'){
					this_.F_alertMsg(this_.F_getErrMSg(err,"登录失败:"),4)
				}else{ // 扫码操作执行
					clearTimeout(this_.$data.timer)
					if (res.data.status === 1){
						setToken(res.data.token)
						this_.F_LOGIN()
						this_.$router.push('/')
						this_.F_alertMsg('登录成功',2)
					}else if (res.data.status === 2){
						this_.$data.bindAccountObj.visible = true
						this_.$data.bindAccountObj.oauth2UserId = res.data.oauth2UserId
					}
				}
			}).catch(err => {
				clearTimeout(this_.$data.timer)
				this_.F_alertMsg(this_.F_getErrMSg(err,"获取扫码状态出现错误"),4)
			})
		},
		createCode : function(this_) {
			this_ = this_ || this
			// 开启遮罩
			this_.$data.createCodeLoading = true
			api_createInvitationCode_userInfo().then(res => {
				this_.F_LOGIN()
				// 关闭遮罩
				this_.$data.createCodeLoading = false
				this_.F_alertMsg('创建邀请码成功', 2)
			}).catch(err => {
				// 关闭遮罩
				this_.$data.createCodeLoading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '创建失败:'), 4)
			})
		},
		getMembershipByLevel : function(val){
			return this.membershipMap.find(item => item.level === val)
		}
	},
	watch: {}
}
</script>

<style scoped>
.user-info-main-div{
	padding: 20px;
}
</style>
<style>
.el-descriptions-custom20221012 > .el-descriptions__body tbody tr{

}
.el-descriptions-custom20221012 > .el-descriptions__body tbody td{
	border-top: 1px solid #E4E7ED;
	padding-bottom: 0 !important;
	line-height: 3rem !important;
}
</style>